import { FormFields } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";

export const fields: FormFields = [
  {
    name: "balance",
    title: $t("Current Balance"),
    type: "balance"
  },
  {
    name: "amount",
    title: $t("Corrected on amount"),
    placeholder: $t("+50"),
    rules: [
      v => !isNaN(Number(v)) || v === undefined || ["-", "+", ""].indexOf(v) > -1 || $t("Amount should be number"),
      v => v === undefined || v === "" || Number(v) > 0 || Number(v) < 0 || $t("Amount can't be zero")
    ]
  },
  {
    name: "description",
    title: $t("Note"),
    placeholder: $t("e.g. gift or penalty")
  },
  {
    name: "apply",
    title: $t("Apply"),
    type: "button"
  }
];
